import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import DefaultComponent from "./DefaultComponent";
import { getComponent, getContextModules } from "../../../lib/requireContextHelper";

const context = require.context(".", true, /\.\/[a-zA-Z]*\/index.ts/);
const modules = getContextModules(context);

function getIntegration(currentSystem: PaymentSystemPublic | null) {
  return getComponent(modules, currentSystem, DefaultComponent);
}

export default getIntegration;
